import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import { ServicesURL } from "@utils/utilsApi";

export interface StaticGroupsDiff {
  addGroupIds: number[];
  removeGroupIds: number[];
}

const toNumberSet = (ids: (string | number)[]): Set<number> =>
  new Set(ids.map((id) => Number(id)).filter((id) => !Number.isNaN(id)));

export const diffStaticGroups = (
  initial: (string | number)[],
  current: (string | number)[],
): StaticGroupsDiff => {
  const initialSet = toNumberSet(initial);
  const currentSet = toNumberSet(current);
  return {
    addGroupIds: Array.from(currentSet).filter((id) => !initialSet.has(id)),
    removeGroupIds: Array.from(initialSet).filter((id) => !currentSet.has(id)),
  };
};

export const hasStaticGroupsChanges = (diff: StaticGroupsDiff): boolean =>
  diff.addGroupIds.length > 0 || diff.removeGroupIds.length > 0;

export const updateUserStaticGroups = async (
  userId: number | string,
  diff: StaticGroupsDiff,
) =>
  fetcher(ServicesURL.putUserStaticGroups, MethodType.PUT, {
    user_id: Number(userId),
    add_group_ids: diff.addGroupIds,
    remove_group_ids: diff.removeGroupIds,
  });
